export { SplashLoadingIndicator } from './splash-loading-indicator';
